/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useState } from 'react';
import { IPage } from 'src/interfaces';

import {
  Container,
  Breadcrumb,
  PageTitle,
  SectionTitle,
  TableWrapper,
  Table,
  Thead,
  Th,
  Tr,
  Td,
  StatusCell,
  StatusBar,
  LinkText,
  SortIcon,
} from './viewHistorystyles';

import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import ExpenseService from 'src/services/expense.service';

import { Link, useParams, useNavigate } from 'react-router-dom';
import { ExpenseHistoryModal } from './modals/expense-history-modal';

export const formatExpenseDate = (isoDate: string): string => {
  const date = new Date(isoDate);

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12 || 12;

  return `${month}/${day}/${year} ${hours}:${minutes}${ampm}`;
};

const ExpenseHistory: React.FC<IPage> = () => {
  const [historyModalIsOpen, setHistoryModalIsOpen] = useState<boolean>(false);
  const [selectedHistory, setSelectedHistory] = useState<any>(null); // store row data here
  const { t } = useTranslation();
  const { expenseId } = useParams<{ expenseId: string }>();
  const navigate = useNavigate();

  const {
    isFetching: isInvocieFetching,
    data: expenseData,
    refetch: expenseRefetch,
  } = useQuery(['expense-details'], async () => {
    const result = await ExpenseService.getExpenseDetails({ expenseId: expenseId });
    return result.data;
  });

  const { isFetching, data, refetch } = useQuery(['expense-history'], async () => {
    const result = await ExpenseService.getExpenseHistory({ expenseId: expenseId });
    return result;
  });

  return (
    <Container>
      <ExpenseHistoryModal isOpen={historyModalIsOpen} setIsOpen={setHistoryModalIsOpen} data={selectedHistory} />

      <Breadcrumb>
        <Link to="/expenses">Search Expense</Link> &gt;{' '}
        <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => navigate(-1)}>
          Expense Details
        </span>
      </Breadcrumb>

      <PageTitle>History</PageTitle>

      {/* Expense Table */}
      <SectionTitle>Expense</SectionTitle>
      <TableWrapper>
        <Table>
          <Thead>
            <Tr>
              <Th>ID</Th>
              <Th>Worker</Th>
              <Th>Period Ending</Th>
              <Th>Client</Th>
              <Th>Job Title</Th>
              <Th>Hire Type</Th>
              <Th>Total</Th>
              <Th>Status</Th>
              <Th>Version</Th>
            </Tr>
          </Thead>

          <tbody>
            <Tr>
              <Td>{expenseData?.expenseShowId}</Td>
              <Td>{expenseData?.employeeName}</Td>
              <Td>{expenseData?.weekEnd}</Td>
              <Td>{expenseData?.clientName}</Td>
              <Td>{expenseData?.jobTitle}</Td>
              <Td>{expenseData?.hireType}</Td>
              <Td>
                {expenseData?.currency}{' '}
                {expenseData?.totalAmount != null ? Number(expenseData.totalAmount).toFixed(2) : '--'}
              </Td>
              <Td>
                <StatusCell>{expenseData?.status}</StatusCell>
              </Td>
              <Td>{expenseData?.version}</Td>
            </Tr>
          </tbody>
        </Table>
      </TableWrapper>

      {/* Change History Table */}
      <SectionTitle>Change History</SectionTitle>
      <TableWrapper>
        <Table>
          <Thead>
            <Tr>
              <Th>Timestamp</Th>
              <Th>User Name</Th>
              <Th>Action Type</Th>
              <Th>Details</Th>
            </Tr>
          </Thead>

          <tbody>
            {data?.map((historyItem: any) => (
              <Tr key={historyItem.timestamp}>
                <Td>{formatExpenseDate(historyItem.timestamp)}</Td>
                <Td>{historyItem.userName}</Td>
                <Td>{historyItem.actionType}</Td>
                <Td>
                  <LinkText
                    onClick={() => {
                      setSelectedHistory(historyItem); // set clicked row data
                      setHistoryModalIsOpen(true); // open modal
                    }}
                  >
                    View Details
                  </LinkText>
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </TableWrapper>
    </Container>
  );
};

export default ExpenseHistory;
